// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.mat-mdc-checkbox {
  display: flex;
  align-content: flex-start;
  margin: 10px 8px auto 0;
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.mat-mdc-checkbox .mat-checkbox-layout {
  white-space: normal;
}
.mat-mdc-checkbox .mat-checkbox-inner-container {
  margin-top: 5px;
}

mat-tab-group .mdc-tab {
  font-weight: bold;
  color: #000000;
}
mat-tab-group .mdc-tab--active {
  color: #0066b2;
}

mat-expansion-panel-header .mat-content {
  flex: 0;
  flex-basis: content;
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dictionary-toolbar {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 3% 0;
  min-width: 0;
  width: 100%;
}

.dictionary-toolbar__filter {
  flex: 0 1 220px;
  max-width: 220px;
  min-width: 180px;
}

.dictionary-toolbar__clear,
.dictionary-toolbar__actions,
.dictionary-toolbar__create,
.dictionary-toolbar__export,
.dictionary-toolbar__toggle {
  flex: 0 0 auto;
}

.dictionary-toolbar__clear button,
.dictionary-toolbar__create {
  background-color: white;
  border: none;
  color: #0066b2;
  cursor: pointer;
  white-space: nowrap;
}

.dictionary-toolbar__clear button:disabled {
  box-shadow: none;
  color: #707070;
  cursor: default;
}

.dictionary-toolbar__search {
  align-items: center;
  display: flex;
  flex: 1 1 320px;
  max-width: 680px;
  min-width: 280px;
}

.dictionary-toolbar__search-field {
  align-items: center;
  border: 1px solid #707070;
  display: flex;
  flex: 1 1 auto;
  height: 48px;
  min-width: 0;
}

.dictionary-toolbar__search-field input {
  border: none;
  flex: 1 1 auto;
  font-size: 14px;
  height: 100%;
  min-width: 0;
  outline: none;
  padding: 0 8px;
}

.dictionary-toolbar__clear-search {
  background: transparent;
  border: none;
  color: #0066b2;
  cursor: pointer;
  flex: 0 0 44px;
  height: 40px;
  margin: 0;
}

.dictionary-toolbar__clear-search:hover {
  color: #0b2d71;
}

.dictionary-toolbar__search-button {
  align-items: center;
  background: #0066b2;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  flex: 0 0 60px;
  height: 48px;
  justify-content: center;
}

.dictionary-toolbar__search-button:hover {
  background-color: #0b2d71;
}

.dictionary-toolbar__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-end;
  margin-left: auto;
}

.dictionary-toolbar__toggle,
.dictionary-toolbar__create {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.dictionary-toolbar__create {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  min-height: 44px;
  padding: 8px 12px;
}

@media (max-width: 900px) {
  .dictionary-toolbar__search {
    max-width: none;
  }
  .dictionary-toolbar__actions {
    justify-content: flex-start;
    margin-left: 0;
    width: 100%;
  }
}
/* Wide modal styling for Rating Class and Design Code modals */
.wide-modal .mat-mdc-dialog-container {
  max-width: 1000px;
  width: 90vw;
}

/* Consolidation Mapping add/edit modal */
.consolidation-mapping-modal .mat-mdc-dialog-container {
  width: 600px;
  max-width: 95vw;
}

/* Large component catalog modal styling */
.large-component-catalog-modal .mat-dialog-container {
  padding: 16px;
  height: 90vh;
  max-height: 95vh;
  /* Strong overrides to make the catalog component fill the dialog when used as a modal */
  overflow: auto;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container {
  padding: 8px;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner,
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner * {
  box-sizing: border-box;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-container {
  width: 100%;
  min-width: 0;
  display: block;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-inner {
  width: 100%;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .catalog-table {
  width: 100%;
  min-width: 0;
  table-layout: auto;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
mat-chip.mat-mdc-chip.mat-mdc-standard-chip {
  background-color: #0066b2;
  color: white;
}

mat-radio-button .mat-mdc-radio-button .mat-radio-outer-circle {
  height: 15px;
  width: 15px;
  border-color: #0066b2;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label-content {
  font-size: 9px;
  padding-left: 0px;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label {
  white-space: inherit;
  vertical-align: 0%;
  line-height: initial;
}

.mat-select-panel mat-option.mat-mdc-option {
  margin: auto 0;
  padding: 10px 20px;
  overflow: visible;
  line-height: 130%;
  word-wrap: break-word;
  white-space: pre-wrap;
  height: 100%;
}

.mat-mdc-select-panel.common-notes-panel {
  max-width: none;
  min-width: 100%;
  width: 100%;
  max-height: 250px;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option {
  min-height: 56px;
  height: auto;
  padding: 12px 20px;
  line-height: 1.5;
  max-width: 100%;
  width: 100%;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option .mdc-list-item__primary-text {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-wrap: break-word;
  max-width: 100%;
  width: 100%;
  display: block;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option-text {
  width: 100%;
  max-width: 100%;
}

.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-grid,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-row,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip-set,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip {
  display: none;
}

.dropdown-close-button {
  position: sticky;
  bottom: 0;
  display: block;
  width: 100%;
  padding: 14px 16px;
  text-align: center;
  background-color: #0066CC;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  z-index: 100;
  transition: background-color 0.2s;
  margin: 0;
  border-radius: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.dropdown-close-button:hover {
  background-color: #0052A3;
}

.mat-snack-bar-warning .mdc-snackbar__surface {
  background: rgb(255, 248, 115);
}

.mat-snack-bar-warning .mdc-snackbar__label {
  color: black;
  font-weight: bold;
}

.mat-snack-bar-error {
  background-color: #97002e;
}
.mat-snack-bar-error .mdc-snackbar__surface {
  --mat-snackbar-container-color: \$esra-red;
  --mat-mdc-snack-bar-button-color: rgb(250, 193, 192);
}

.mat-mdc-card {
  box-shadow: none;
}

#pttable .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading {
  width: 1px;
}

#pttable .mdc-text-field--outlined {
  padding-left: 1px;
  padding-right: 1px;
}

.dialogButtons {
  padding-top: 10px;
  float: right;
}

.button-blue {
  background-color: #0066b2;
  border: 1px solid #0066b2;
  color: #ffffff;
}
.button-blue:hover {
  background-color: #0b2d71;
  cursor: pointer;
}

.button {
  margin: none;
}

.text-button {
  display: inline-block;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}
.text-button:hover {
  color: #0b2d71;
  box-shadow: inset 0 -2px 0 0 #0b2d71;
}

.close-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.close-button::before {
  font-family: "Material Icons";
  content: "close";
}
.close-button:hover {
  background-color: rgba(0, 0, 0, 0.16);
  color: #0b2d71;
}

:root ngx-slider {
  transition: none;
  margin: 15px 0px;
  height: 40px;
}
:root ngx-slider .ngx-slider-pointer {
  width: 12px;
  height: 12px;
  top: auto;
  bottom: 26px;
  background-color: #0066b2;
}
:root ngx-slider .ngx-slider-bubble {
  top: auto;
  bottom: 0px;
}
:root ngx-slider .ngx-slider-span {
  color: rgba(0, 0, 0, 0.8705882353);
  font: normal normal medium "Gotham", Arial, sans-serif;
  font-size: 11px;
}
:root ngx-slider .ngx-slider-pointer:after {
  display: none;
}
:root ngx-slider .ngx-slider-bar {
  height: 2px;
  background: rgba(125, 127, 134, 0.7019607843);
  top: auto;
  bottom: 7px;
}
:root ngx-slider .ngx-slider-selection {
  background: #0066b2;
  top: auto;
  bottom: 7px;
}

app-welding-search .mat-mdc-paginator .mat-mdc-paginator-container {
  display: flex;
  justify-content: center;
}

/* You can add global styles to this file, and also import other style files */
.left-align {
  float: left;
}

.right-align {
  float: right;
}

.text-left-align {
  text-align: left;
}

.text-right-align {
  text-align: right;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dialogClose {
  float: right;
  cursor: pointer;
}

.dialogClose div {
  text-align: center;
  margin-top: -6px;
}

.dialogmainheader {
  padding-top: 30px;
}

.dialogmain {
  border: 1px solid gray;
  min-height: 300px;
  max-height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: -15px;
}

.button:enabled,
.primary:enabled,
.secondary:enabled {
  border: 1px solid #0066b2;
}

.button:disabled,
.primary:disabled,
.secondary:disabled {
  border: 1px solid #e3e3e3;
  cursor: default;
}

.container-horizontal {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.required:after {
  content: " *";
  color: red;
}

.pointer {
  cursor: pointer;
}

.progress-bar-container {
  min-height: 6px;
  margin: 1.5rem 3%;
}
.progress-bar-container div {
  height: 5px;
}

.esra-select {
  width: 80%;
}

.width-10 {
  width: 10%;
}

.esra-tooltip {
  --mat-tooltip-supporting-text-size: 0.875rem;
}
.esra-tooltip .mat-mdc-tooltip-surface {
  white-space: pre-line !important;
  max-width: 240px !important;
}

.edit-color {
  color: #0066b2;
}

.delete-color {
  color: #e21836;
}

.mat-sort-header-arrow {
  opacity: 1;
  transform: none;
  color: black;
}

.wrapped-text {
  padding: 1% 0;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.pad-LR-20 {
  padding-left: 20px;
  padding-right: 20px;
}

header,
nav#site-specific-nav,
nav#site-specific-nav.centered-nav,
main,
main.container,
menu,
footer {
  min-width: 85vw;
  min-width: 85dvw;
  max-width: 100vw;
  max-width: 100dvw;
}

.menu-list,
nav#site-specific-nav ul:not(.in-mega) > li .mega-menu,
nav#site-specific-nav ul:not(.in-mega) > li ul:not(.in-mega) {
  width: 100%;
  min-width: 0;
}

.service-selection-dialog .mat-mdc-dialog-container {
  padding: 0;
}
@media (max-width: 768px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 20px;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
  }
}
@media (max-width: 480px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 10px;
    max-width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
  }
}
.service-selection-dialog .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: visible;
}

@media (max-width: 768px) {
  .mat-mdc-dialog-container {
    border-radius: 8px;
  }
}
@media (max-width: 480px) {
  .mat-mdc-dialog-container {
    border-radius: 4px;
  }
}

/* Extra large catalog modal */
.xlarge-component-catalog-modal .mat-dialog-container,
.xlarge-component-catalog-modal .mat-mdc-dialog-container {
  padding: 0;
  width: 100vw;
  max-width: 100vw;
  height: 95vh;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.xlarge-component-catalog-modal .mat-dialog-content,
.xlarge-component-catalog-modal .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.xlarge-component-catalog-modal .mat-dialog-actions,
.xlarge-component-catalog-modal .mat-mdc-dialog-actions {
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0;
  padding: 0;
  min-height: auto;
}

/* Slightly larger typography and controls inside the modal for easier selection */
.xlarge-component-catalog-modal table {
  font-size: 1.05rem;
}

.xlarge-component-catalog-modal .mat-form-field,
.xlarge-component-catalog-modal .search-input-container {
  transform: scale(1.02);
}

/* When the catalog component is hosted inside a modal use these styles */
.table-container.modal-mode {
  display: flex;
  flex-direction: column;
  height: 90%; /* occupy 90% of the dialog */
}

.table-container.modal-mode .table-inner {
  flex: 1 1 auto;
  min-height: 0; /* allow flex child to shrink for scrolling */
  overflow: auto;
  /* ensure horizontal scrolling is possible and visible */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-container.modal-mode .catalog-table {
  /* Allow the table to be wider than the dialog so users get a spacious layout
     and can horizontally scroll inside the modal. Increase min-width to better
     match the dialog's larger layout. */
  width: auto; /* let content set the width */
  min-width: 0; /* don't force a large min-width in modal; allow dialog to constrain width */
  table-layout: auto; /* allow columns to size naturally */
}

/* Optional: style the horizontal scrollbar inside the table-inner for clarity */
.table-container.modal-mode .table-inner::-webkit-scrollbar {
  height: 12px;
}

.table-container.modal-mode .table-inner::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.table-container.modal-mode .modal-confirm-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

/* Make the middle area wider in the extra-large catalog modal: place filters and
   table side-by-side and let the table take the remaining width. */
.xlarge-component-catalog-modal .main-conatiner .middle-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.xlarge-component-catalog-modal .main-conatiner .filter-group-container {
  /* keep filter column compact in modal so table has more room */
  flex: 0 0 260px;
  max-width: 260px;
}

.xlarge-component-catalog-modal .main-conatiner .table-container {
  /* allow table container to expand and use modal-mode rules for internal scrolling */
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for proper overflow handling */
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.ribbon-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.corner-ribbon {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateX(30%) rotate(-45deg);
  transform-origin: bottom left;
  margin: 0;
  padding: 7px 0;
  width: 110px;
  text-align: center;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: white;
  pointer-events: auto;
  cursor: default;
}
.corner-ribbon::before, .corner-ribbon::after {
  content: "";
  position: absolute;
  top: 0;
  margin: 0 -1px;
  width: 100%;
  height: 100%;
}
.corner-ribbon::before {
  right: 100%;
}
.corner-ribbon::after {
  left: 100%;
}
.corner-ribbon.corner-ribbon--draft {
  background-color: #e65100;
}
.corner-ribbon.corner-ribbon--draft::before, .corner-ribbon.corner-ribbon--draft::after {
  background: #e65100;
}
.corner-ribbon.corner-ribbon--retired {
  background-color: #97002e;
}
.corner-ribbon.corner-ribbon--retired::before, .corner-ribbon.corner-ribbon--retired::after {
  background: #97002e;
}
.corner-ribbon.corner-ribbon--archived {
  background-color: #8c8f93;
}
.corner-ribbon.corner-ribbon--archived::before, .corner-ribbon.corner-ribbon--archived::after {
  background: #8c8f93;
}

.main-container {
  padding: 1.5rem 2rem;
  background-color: #f5f6f8;
  min-height: 100%;
}

.back-button {
  margin-bottom: 1.5rem;
  cursor: pointer;
  color: #0066b2;
  border-color: #0066b2;
  background-color: #fff;
  border-radius: 5px;
  padding: 0.4rem 0.9rem;
}

.progress-bar-container {
  min-height: 6px;
  margin-bottom: 0.5rem;
}

.state-card {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  padding: 2rem;
  text-align: center;
  color: #707070;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.page-header {
  margin-bottom: 1.25rem;
}

.title {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 1.6rem;
  color: #0b2d71;
  margin: 0 0 0.25rem;
}

.subtitle {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 0.9rem;
  color: #707070;
  margin: 0;
}

.user-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  padding: 1.25rem;
  margin-bottom: 1.25rem;
}

.user-detail {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.user-detail-label {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #707070;
}

.user-detail-value {
  font-size: 0.95rem;
  color: #222;
}

.user-card-spacer {
  flex: 1 1 auto;
}

.refresh-button {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.stale-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background-color: #fff4e5;
  border: 1px solid #f0b429;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.25rem;
  color: #7a5200;
  font-size: 0.9rem;
}

.business-units-card {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  padding: 1.25rem;
  margin-bottom: 1.25rem;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.section-title {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 1.1rem;
  color: #0b2d71;
  margin: 0 0 0.25rem;
}

.section-description {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 0.85rem;
  color: #707070;
  margin: 0;
}

.assigned-count-badge {
  flex: 0 0 auto;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 0.78rem;
  color: #0066b2;
  background-color: #e3edf9;
  border-radius: 12px;
  padding: 4px 12px;
  white-space: nowrap;
}

.business-unit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.75rem;
}

.business-unit-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border: 1px solid #e0e3e8;
  border-radius: 6px;
  padding: 0.6rem 0.9rem;
  background-color: #fafbfc;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.business-unit-card:hover:not(.disabled) {
  border-color: #0066b2;
}

.business-unit-card.checked {
  border-color: #0066b2;
  background-color: #eef4fb;
}

.business-unit-card.disabled {
  cursor: default;
}

.tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-family: "GothamBold", Arial, sans-serif;
}

.tag-mandatory {
  background-color: #e3edf9;
  color: #0066b2;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
  color: #707070;
}

.actions-row {
  display: flex;
  justify-content: flex-end;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
